


export const url_studentWorkUpload = "/student/research-work-upload";
export const url_studentTopicUpload = "/student/research-topics";